import SwitchCustomer from './switchcustomer'

export default SwitchCustomer